import React, { useEffect, useState } from 'react';
import { Globe, ShoppingBag } from 'lucide-react';
import appDataService, { Shop } from '../services/appDataService';
import ListingExplorer, {
  ListingFilterDef,
  ListingBadge,
  ListingCta,
  ListingItem,
} from '../components/listings/ListingExplorer';

const shopLinkOf = (item: ListingItem): string | null => {
  const link = (item as Shop).shopLink;
  if (link && typeof link === 'string' && link.trim().length > 0) {
    const trimmed = link.trim();
    return trimmed.startsWith('http') ? trimmed : `https://${trimmed}`;
  }
  return null;
};

const FILTERS: ListingFilterDef[] = [
  {
    key: 'online',
    label: 'Online-Shop',
    icon: Globe,
    test: (i) => !!shopLinkOf(i),
  },
];

const badgesFor = (item: ListingItem): ListingBadge[] => {
  const badges: ListingBadge[] = [];
  if (shopLinkOf(item)) {
    badges.push({ key: 'online', label: 'Online-Shop', icon: Globe });
  }
  return badges;
};

const ctaFor = (item: ListingItem): ListingCta | null => {
  const link = shopLinkOf(item);
  return link ? { label: 'Zum Shop', href: link } : null;
};

const ShopsPage: React.FC = () => {
  const [shops, setShops] = useState<Shop[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    appDataService
      .getShops()
      .then((data) => {
        if (!cancelled) setShops(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (!cancelled) setShops([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <ListingExplorer
      items={shops}
      loading={loading}
      title="Dart-Shops"
      subtitle="Finde deinen nächsten Dart-Shop: Darts, Boards & Zubehör – online bestellen oder vor Ort testen."
      searchPlaceholder="Shop oder Ort suchen..."
      countLabel="Shops"
      countLabelSingular="Shop"
      cardCta={ctaFor}
      emptyIcon={ShoppingBag}
      fallbackIcon={ShoppingBag}
      emptyLabel="Keine Shops gefunden"
      routeBase="/shop"
      filters={FILTERS}
      badges={badgesFor}
      seoTitle="Dart-Shops & Equipment | DartCloud"
      seoDescription="Finde Dart-Shops für Equipment, Boards und Zubehör – online und in deiner Nähe auf DartCloud."
    />
  );
};

export default ShopsPage;
